export function paygClientReducer(state = "",{
    type,
    payload
}){
    
    switch(type){
        case "NEW_PAYG_CLIENT":  
            return {
                ...state,
                [payload.id]: payload
            }

        case "NEW_PAYG_CLIENTS":  
            const updatedState = { ...state };
            payload.forEach(client => {
                updatedState[client.id] = {
                    ...updatedState[client.id],
                    ...client
                };
            });
            return updatedState;

        case "GET_ALL_CLIENTS_REPORTS": 
            // Build updates separately to avoid reference issues
            const updatedReportsState = {};
            
            payload.forEach(report => { 
                if (state[report.boxAssoId]) {
                    if (!updatedReportsState[report.boxAssoId]) {
                        // Deep copy to prevent mutation
                        updatedReportsState[report.boxAssoId] = {
                            ...state[report.boxAssoId],
                            reports: state[report.boxAssoId].reports 
                                ? [...state[report.boxAssoId].reports]
                                : []
                        };
                    }
                    // Now safe to push to the copied array
                    updatedReportsState[report.boxAssoId].reports.push(report.id);
                }              
            });
            
            return {
                ...state,
                ...updatedReportsState
            };
        
        case "ADD_CLIENT_REPORT": 
            if (state[payload.boxAssoId]) {
                const existingReports = state[payload.boxAssoId].reports || [];
                return {
                    ...state,
                    [payload.boxAssoId]: {
                        ...state[payload.boxAssoId],
                        reports: [...existingReports, payload.reportID]
                    }
                };
            }
            return state;
        
        case "GET_ALL_CLIENTS_PAYMENTS": 
            // Build the updated state in one pass, avoid recreating entire state in loop
            const updatedClientsState = {};
            
            payload.forEach(payment => {
                const boxAssoId = payment.boxAssoId;
                
                if (!updatedClientsState[boxAssoId]) {
                    // Initialize this client's entry (deep copy nested arrays to prevent mutation)
                    if (state[boxAssoId]) {
                        updatedClientsState[boxAssoId] = {
                            ...state[boxAssoId],
                            // Deep copy the payments array if it exists to avoid mutation
                            payments: state[boxAssoId].payments 
                                ? [...state[boxAssoId].payments] 
                                : []
                        };
                    } else {
                        updatedClientsState[boxAssoId] = { payments: [] };
                    }
                }
                
                // Add payment to the array (array is now safely copied)
                updatedClientsState[boxAssoId].payments.push(payment.paymentID);
            });

            // Merge with existing state only once at the end
            return {
                ...state,
                ...updatedClientsState
            };     
            
        case "ADD_CLIENT_PAYMENT": 
            if (state[payload.boxAssoId]) {
                const existingPayments = state[payload.boxAssoId].payments || [];
                return {
                    ...state,
                    [payload.boxAssoId]: {
                        ...state[payload.boxAssoId],
                        payments: [...existingPayments, payload.paymentID]
                    }
                };
            }
            return state;

        case "GET_CLIENT_RECOVERY": 
            return {
                ...state,
                [payload.boxId]: {
                    ...state[payload.boxId],
                    recovery: payload.recovery
                }
            };
            
        case "ADD_CLIENT_RECOVERY": 
            if (state[payload.boxId]) {
                const existingRecovery = state[payload.boxId].recovery || [];
                return {
                    ...state,
                    [payload.boxId]: {
                        ...state[payload.boxId],
                        recovery: [...existingRecovery, payload.recoveryID]
                    }
                };
            }
            return state;
        
        case "GET_PAYG_CLIENTS":
            // Build updates separately to avoid reference issues
            const updatedPaygState = {};
            
            Object.keys(payload).forEach(boxAssoId => {  
                if (state[boxAssoId]) {
                    // When merging, explicitly deep copy nested arrays to prevent mutation
                    const mergedState = {
                        ...state[boxAssoId],
                        ...payload[boxAssoId]
                    };
                    
                    // Deep copy any nested arrays that came from state (not overwritten by payload)
                    updatedPaygState[boxAssoId] = {
                        ...mergedState,
                        // Only deep copy if array exists and wasn't replaced by payload
                        ...(mergedState.payments && mergedState.payments === state[boxAssoId]?.payments
                            ? { payments: [...mergedState.payments] }
                            : {}),
                        ...(mergedState.reports && mergedState.reports === state[boxAssoId]?.reports
                            ? { reports: [...mergedState.reports] }
                            : {}),
                        ...(mergedState.recovery && mergedState.recovery === state[boxAssoId]?.recovery
                            ? { recovery: [...mergedState.recovery] }
                            : {})
                    };
                } else {
                    updatedPaygState[boxAssoId] = payload[boxAssoId];
                }            
            });

            return {
                ...state,
                ...updatedPaygState
            };
        
        case "UPDATE_PAYG_CLIENTS":
            // Build the updated state in one pass, avoid recreating entire state in loop
            const updatedPaygClients = {};
            
            Object.keys(payload.list).forEach(ID => {
              if (state[ID]) {
                // Client exists in state, merge the data with proper deep copying
                const baseUpdate = {
                  ...state[ID],
                  resume: {
                    ...state[ID].resume,
                    ...payload.list[ID].resume,
                    [payload.info_type]: true,
                  },
                  [payload.info_type]: true,
                };
                
                // Deep copy nested arrays that came from state to prevent mutation
                updatedPaygClients[ID] = {
                  ...baseUpdate,
                  ...(baseUpdate.payments && baseUpdate.payments === state[ID].payments
                    ? { payments: [...baseUpdate.payments] }
                    : {}),
                  ...(baseUpdate.reports && baseUpdate.reports === state[ID].reports
                    ? { reports: [...baseUpdate.reports] }
                    : {}),
                  ...(baseUpdate.recovery && baseUpdate.recovery === state[ID].recovery
                    ? { recovery: [...baseUpdate.recovery] }
                    : {})
                };
              } else {
                // New client entry
                updatedPaygClients[ID] = {
                  resume: {
                    ...payload.list[ID].resume,
                    [payload.info_type]: true,
                  },
                  [payload.info_type]: true,
                };
              }
            });
          
            // Merge with existing state only once at the end
            return {
              ...state,
              ...updatedPaygClients
            };
        
        default:
            return state;
    }
    
}